export const baseUsersUrl = '/users/profile'
